import { GQL } from "./GQL"
import { openNotificationWithIcon } from "../components/Notification"
import { MUTATION_CHANGE_GATEWAY_PLAN } from "./mutations"

export async function updateGatewayPlan(input: GatewayPlanInput) {
  try {
    return await GQL.request(MUTATION_CHANGE_GATEWAY_PLAN, { input })
  } catch (error) {
    openNotificationWithIcon("error", "Erro na operação", "Erro inesperado!")
  }
}
